module.exports = __webpack_public_path__ + "static/media/bgimage.0049d952.jpg";